import {
  AfterViewInit,
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { FormBuilder, ReactiveFormsModule } from '@angular/forms'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { VehicleModelService } from '../../../../core/services/vehicle/vehicle-model/vehicle-model.service'
import { VehicleTypeService } from '../../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { MatProgressBar } from '@angular/material/progress-bar'

import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource,
} from '@angular/material/table'
import { MatPaginator, PageEvent } from '@angular/material/paginator'
import { PagedContactTypeResponse } from '../../../../core/models/contact-type.model'
import { PurchasesQuoteRequestService } from '../../../../core/services/purchases/purchases-quote-request/purchases-quote-request.service'
import { SupplierService } from '../../../../core/services/person/supplier/supplier.service'
import { MatTableModule } from '@angular/material/table'
import { MatCardModule } from '@angular/material/card'
import { TelefonePipe } from '../../../../shared/pipes/phone.pipes'
import { CnpjPipe } from '../../../../shared/pipes/cpnj.pipes'
import { PurchasesQuoteItemSupplierService } from '../../../../core/services/purchases/purchases-quote-item-supplier/purchases-quote-item-supplier.service'
import { MatTooltip } from '@angular/material/tooltip'
import { PurchasesQuoteSupplierService } from '../../../../core/services/purchases/purchases-quote-supplier/purchases-quote-supplier.service'
import { JsonPipe, NgClass, NgIf } from '@angular/common'
import { PurchasesQuoteSupplierTgPriceComponent } from '../purchases-quote-supplier-tg-price/purchases-quote-supplier-tg-price.component'
import { ModalPurchasesSupplierItinerariesComponent } from '../modal-purchases-supplier-itineraries/modal-purchases-supplier-itineraries.component'

@Component({
  selector: 'purchases-quote-supplier-tg-view',
  imports: [
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatProgressBar,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatPaginator,
    MatRow,
    MatRowDef,
    MatTable,
    MatTableModule,
    MatCardModule,
    TelefonePipe,
    CnpjPipe,
    MatTooltip,
    JsonPipe,
    MatIcon,
    NgIf,
    NgClass,
  ],
  templateUrl: './purchases-quote-supplier-tg-view.component.html',
  styleUrl: './purchases-quote-supplier-tg-view.component.scss',
  providers: [VehicleModelService, VehicleTypeService],
  standalone: true,
})
export class PurchasesQuoteSupplierTgViewComponent
  implements OnInit, AfterViewInit
{
  constructor(
    private formBuilder: FormBuilder,
    private purchasesQuoteRequestService: PurchasesQuoteRequestService,
    private purchasesQuoteSupplierService: PurchasesQuoteSupplierService,
    private purchasesQuoteItemSupplierService: PurchasesQuoteItemSupplierService,
    private supplierService: SupplierService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<PurchasesQuoteSupplierTgViewComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.item = data
  }

  item: any = {}
  loading = false
  editItem = false
  itemPurchases: any = {}

  @Output() response = new EventEmitter()
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  columns: any[] = [
    {
      keyColumn: 'type',
      key: 'tipoTarifario',
      description: 'Tipo Tarifário',
    },
    {
      keyColumn: 'location_OD',
      key: 'origem',
      description: 'Trecho',
    },
    {
      keyColumn: 'servico_TS',
      key: 'tipoServico',
      description: 'Serviço',
    },
    {
      keyColumn: 'vehicle_VM',
      key: 'tipoVeiculo',
      description: 'Veículo',
    },
    {
      keyColumn: 'period_date',
      key: 'data',
      description: 'Período',
    },
    {
      keyColumn: 'itensComplete',
      key: 'complete',
      description: 'Orçados',
    },
    // {
    //   keyColumn: 'status',
    //   key: 'descricaoStatus',
    //   description: 'Status',
    // },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]
  page = 1
  rows = 10
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()

  loadingEmail = false
  loadingFinish = false
  closeRequest = false

  displayedColumns: string[] = [
    'type',
    'location_OD',
    'servico_TS',
    'vehicle_VM',
    'period_date',
    'itensComplete',
    'action',
  ]

  ngOnInit(): void {
    this.getListItems()
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  close() {
    this.dialogRef.close()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    if (this.table) {
      this.table.renderRows()
    }
  }
  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({
          ...item,
          totalCotacaoRealizada: item.totalCotacaoRealizada ?? 0,
          totalCotacao: item.totalCotacao ?? 0,
        })
      }
    }
    this.tableSource = new MatTableDataSource<any>(list)
    this.refreshTable()
    if (this.closeRequest) {
      if (list.length == 0) {
        this.response.emit(true)
        this.close()
      } else {
        this.closeRequest = false
      }
    }
  }

  pageChanged(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
  }

  uploadList(type = '') {
    this.getListItems()
    // if (type == 'new') {
    //   this.searchForm = { search: false, model: {} }
    // }
    // if (this.searchForm.search) {
    //   this.searchAddress()
    // } else {
    //   this.getListItems()
    // }
  }

  responseForm(response: any): void {
    if (response.refresh) {
      this.uploadList()
    }
    if (response.clear) {
      this.clearItem()
    }
  }

  clearItem() {
    this.editItem = false
    this.itemPurchases = {}
  }

  createModel() {
    return {
      cotacaoId: this.item.id,
      statusItemCotacaoId: 0,
    }
  }

  getListItems() {
    this.loading = true
    const model = this.createModel()
    this.purchasesQuoteSupplierService
      .listPagedPurchasesQuoteSupplierByTGId(this.item.propostaId)
      .subscribe({
        next: (response: any) => {
          if (response.statusCode == 206) {
            this.response.emit(true)
            this.close()
          } else {
            this.treatResponse(response)
          }
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  finishQuote() {
    this.loadingFinish = true
    const model = { id: this.item.id }
    this.purchasesQuoteSupplierService
      .editFinalPurchasesQuoteSupplier(model)
      .subscribe({
        next: (response: any) => {
          this.snackbar.success(response.message)
          this.response.emit(true)
          this.close()
        },
        error: (err: PagedContactTypeResponse) => {
          this.loadingFinish = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loadingFinish = false
        },
      })
  }

  viewSuppliers(item: any) {
    const dialogRef = this.dialog.open(PurchasesQuoteSupplierTgPriceComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { item: item, proposal: this.item },
    })
    dialogRef.afterClosed().subscribe((response) => {
      this.uploadList()
    })
    // dialogRef.componentInstance.response.subscribe((response) => {
    //   if (response) {
    //     this.uploadList()
    //   }
    // })
  }

  viewItinerariesItem(item: any) {
    const dialogRef = this.dialog.open(
      ModalPurchasesSupplierItinerariesComponent,
      {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        width: '1000px',
        maxWidth: '1000px',
        maxHeight: '620px',
        data: { item: item },
      },
    )
    // dialogRef.afterClosed().subscribe((response) => {
    //   this.uploadList()
    // })
  }

  finishRequest(item: any) {
    this.loadingFinish = true
    this.closeRequest = false
    this.purchasesQuoteSupplierService
      .finishPurchasesQuoteSupplierByRequestId(item.id)
      .subscribe({
        next: (response: any) => {
          this.snackbar.success(response.message)
          this.closeRequest = true
          this.uploadList()
        },
        error: (err: PagedContactTypeResponse) => {
          this.loadingFinish = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loadingFinish = false
        },
      })
  }
}
